export default {"src":"/_next/static/media/white-label-dmp-dsp.e00984bc.svg","height":505,"width":725,"blurWidth":0,"blurHeight":0};